import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button,
  Card,
  Label,
  Table,
  Dimmer,
  List
} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

import { BACKGROUND_DARK, BACKGROUND_DARK2, PRIMARY_COLOR } from '../constants';
import AudoryCoinIcon from '../img/AudoryCoinIcon';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '1.2em' : '2.5em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.press.headText"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.5em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.press.bodyText"/>
        </Header>
        
        </Container>
    </Segment>
)

class PressPage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            audioSrc: null,
            audio: {},
            activePay: null,
        };
    }


    render(){
        /*
<Header as='h3' style={{ fontSize: '2em', marginTop: '2em' }}>
                      <FormattedMessage id="audory.temp.4"/>
                    </Header>
        */
        return (
            <DivWrapper>
                <PageHeader />
              <Segment style={{ padding: '3em 0em', margin: 0 }}>
                  
                  <Container text>
                    <Header as='h2' style={{ fontSize: '2.8em', marginBottom: '0.5em' }}>
                        Schnell und einfach
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify'}}>
                        Wir möchten Ihnen die Pressearbeit so einfach wie möglich machen und sind offen für alle Arten von Anfragen! Schreiben Sie uns gerne eine E-Mail, wenn sie noch offene Fragen haben. Wir freuen uns über jede Form der Berichterstattung!
                        Wenn Sie über audory berichten möchten, können Sie gerne folgendes Pressematerial nutzen. Bitte verlinken Sie gern unsere Website oder unsere Social-Media Kanäle!
                    </p>
                    <center>
                        <Image bordered rounded size='huge' src='https://audory-static.s3.eu-central-1.amazonaws.com/press_1.jpg' />
                    </center>
                        <Grid style={{marginTop: '0.5em'}}>
                            <Grid.Column textAlign='center'>
                                <a href={"https://audory-static.s3.eu-central-1.amazonaws.com/press/Presse.zip"} target='_blank'>
                                    <Button labelPosition='right' icon='right chevron' size='huge' content='Zum Pressematerial' />
                                </a>
                            </Grid.Column>
                        </Grid>
                    

                    <Header as='h2' style={{ fontSize: '2.8em', marginTop: '2em', marginBottom: '0.5em' }}>
                        Aktuelle Berichterstattung
                    </Header>
                    <List divided relaxed>
                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.tu-chemnitz.de/tu/pressestelle/aktuell/11191">Technische Universität Chemnitz</List.Header>
                                <List.Description>Chemnitzer Start-up in der „Höhle der Löwen“</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.tag24.de/unterhaltung/tv/die-hoehle-der-loewen/mit-dieser-idee-hat-es-ein-chemnitzer-unternehmer-in-die-hoehle-der-loewen-geschafft-2403070">audory bei Tag24</List.Header>
                                <List.Description>Mit dieser Idee hat es ein Chemnitzer Unternehmer in die "Höhle der Löwen" geschafft</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.tu-chemnitz.de/tu/pressestelle/aktuell/11062">Interaktive Studienorientierung der Technischen Universität Chemnitz</List.Header>
                                <List.Description>Hörbuch „Klassenfahrt“ – Studienorientierung mal ganz anders</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.saechsische.de/sachsen/audory-die-story-bestimmt-jeder-fuer-sich-interaktive-hoerspiele-sachsen-chemnitz-genial-saechsische-5360653.html">audory zu "Genial sächsisch" bei Sächsische.de</List.Header>
                                <List.Description>"Die Story im Hörbuch läuft jedes Mal anders"</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://global.techradar.com/de-de/news/audory-gestalte-horbucher-interaktiv">audory bei techradar</List.Header>
                                <List.Description>audory - Gestalte Hörbücher interaktiv</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='microphone' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://leanderwattig.com/wasmitbuechern/2021/max-rose-mit-audory-entwickeln-wir-eine-plattform-fuer-interaktive-hoerbuecher/">Interview bei leanderwattig.com</List.Header>
                                <List.Description>Max Rose: Mit »audory« entwickeln wir eine Plattform für interaktive Hörbücher</List.Description>
                            </List.Content>
                        </List.Item>

                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://innovationszentren-sachsen.de/de/aktuelles/gro%C3%9Fe-entwicklungsreife-viel-potenzial/">Arbeitsgemeinschaft Technologiezentren Sachsen (AG TZ-S)</List.Header>
                                <List.Description>Die TU Chemnitz und die Sächsische Aufbaubank haben drei neue Sieger ihres gemeinsamen TUClab-Wettbewerbs gekürt</List.Description>
                            </List.Content>
                        </List.Item>
                        
                        <List.Item>
                            <List.Icon name='at' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.tag24.de/chemnitz/audory-spezialist-fuer-interaktive-geschichten-chemnitzer-start-up-macht-hoerer-zu-helden-individuelle-storys-1795763">audory bei Tag24</List.Header>
                                <List.Description>Interaktive Geschichten mit "audory": Hier entscheidest du, wie Hörbücher enden!</List.Description>
                            </List.Content>
                        </List.Item>


{
    /*
                        <List.Item>
                            <List.Icon name='microphone' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header as='a' target='_blank' href="https://www.texthungrig.com/interview-mit-max-rose">Interview bei texthungrig</List.Header>
                                <List.Description as='a'>"Interaktive Hörspiele sind die Musik der Zukunft"</List.Description>
                            </List.Content>
                        </List.Item>
    */
}
                        
                    </List>
          
                      <Header as='h2' style={{ fontSize: '2.8em', marginTop: '2em' }}>
                          Haben Sie noch Fragen?
                      </Header>
                      <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                        Kommen Sie gerne auf uns zu und schreiben sie Ihre offenen Fragen an <a style={{color: PRIMARY_COLOR}} target='_blank' href="mailto:max.rose@audory.de?subject=Presseanfrage">max.rose@audory.de</a>!
                      </p>

                    <center>
                        <a target='_blank' href={"mailto:max.rose@audory.de?subject=Presseanfrage"}>
                            <Button labelPosition='right' icon='mail' size='huge' content='E-Mail schreiben' />
                        </a>
                    </center>

                          
                  </Container>
              </Segment>
            </DivWrapper>
          );
    }
} 



export default PressPage;


// WEBPACK FOOTER //
// ./src/components/PressPage.js